export * from "/__w/wiggot-web/wiggot-web/packages/web-components/charts/services/hexa.service.ts"